module.exports = __webpack_public_path__ + "static/media/skyPrecision1.76049aa5.png";